module.exports = __webpack_public_path__ + "img/loading.ef7a546b.webp";